

/*
	Source: htdocs/wim/js/core/src/ModalWindow.js
*/
(function($, wimbledonCore) {
function ModalWindow() {
        var id = 'ModalWindow';
        var logger = new eventsCore.util.Logger(id);
        var overlayHtml = "<div id='overlayBackground'></div>";
        var modalHtml = "<div id='modalContent'><div class='modalContainer'><div class='close' onclick='wimbledonCore.modalWindow.close();'></div><div class='content'></div></div></div>";

        var load = function(obj){
        	var modalData = obj.attr('data-url');

        	$.getJSON( modalData, function(data) {
        		render(data);
			}).fail(function(jqXHR, textStatus, errorThrown) {
				logger.info( errorThrown );
			});
		};
        var render = function(data){
        	if($("#overlayBackground").length == 0) {
        		$("body").append(overlayHtml);
        	}

        	if($("#modalContent").length == 0) {
        		$("body").append(modalHtml);
        	}

            $('.modalContainer').toggleClass('large', data.modalData.type === 'large');

        	var modalHtmlContent = "";
        	modalHtmlContent += '<img src="'+data.modalData.photo+'" />';
        	modalHtmlContent += '<div class="text">';
        	modalHtmlContent += '	<h2>'+data.modalData.title+'</h2>';
        	modalHtmlContent += '	<div class="subtitle">'+data.modalData.subtitle+'</div>';
        	modalHtmlContent += 	data.modalData.content;
        	modalHtmlContent += '</div>';

        	$(".modalContainer .content").html(modalHtmlContent);

        	_open();
        };
        var _open = function() {
        	$("#overlayBackground").fadeIn();
        	$("#modalContent").fadeIn();
        };
        var _close = function(){
        	$("#modalContent").fadeOut();
        	$("#overlayBackground").fadeOut();
        };

        return {
            close: _close,
            open: _open,
            render: render,
            load: load
        };
    };

    wimbledonCore.modalWindow = new ModalWindow;

}(jQuery, window.wimbledonCore));